module.exports = __webpack_public_path__ + "img/noImage.4562d3d8.svg";